// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1jEVl","footer":"ModalUpdate_footer__2b11w"};